var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"timeline__item"},[_c('span',{staticClass:"timeline__item__dot",class:{
      'timeline__item__dot--primary': _vm.dotColor === 'primary',
      'timeline__item__dot--secondary': _vm.dotColor === 'secondary',
      'timeline__item__dot--error': _vm.dotColor === 'error',
    }}),_c('h4',{staticClass:"timeline__item__title",domProps:{"innerHTML":_vm._s(_vm.title)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }